import React from 'react';

import { useIntl } from 'react-intl';

import Image from '@atlaskit/image';

import { GlobalSideNavigationNoContent } from '../../../../common/ui/no-content';

// eslint-disable-next-line import/extensions -- Jest resolves SVG assets in this package only when the extension is present.
import Empty from './assets/empty.svg';
import messages from './messages';

export function ObjectListFlyoutEmptyState(): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<GlobalSideNavigationNoContent
			testId="object-list-flyout--empty-state"
			renderImage={() => <Image src={Empty} width={96} alt="" />}
			heading={formatMessage(messages.emptyStateHeader)}
			description={formatMessage(messages.emptyStateDescription)}
		/>
	);
}
